<template>
  <div class="driver-shortest-route-map">
    <div class="map-wrapper">
      <div :id="mapID" class="map" />
    </div>

    <div class="bottom is-flex">
      <p @click="close" style="flex-shrink: 1">
        <i v-if="isClosed" class="fa fa-spinner fa-spin" />
        <i v-else class="fa fa-chevron-left" />
        {{ $t("back") }}
      </p>
      <p style="flex: 1" @click="showFareDistanceKM">
        <span class="distance">{{ Math.ceil(fareDistanceKM) }}km</span>
        <span v-if="disputeDistance" class="distance dark" @click="viewScreenshot">{{ disputeDistance }} km</span>
      </p>
      <p style="flex-shrink: 1">
        <span v-if="screenshot" class="distance" @click="viewScreenshot"><i class="fa fa-image" /></span>
        <span v-else class="distance" @click="preDispute">{{ $t("driver.dispute") }}</span>
      </p>
    </div>

    <div v-if="disputeStatus" class="dispute">
      {{ $t("driver.dispute-status") }}
      <span class="dispute-distance has-text-weight-bold">
        <span v-if="disputeStatus === 'ongoing'" class="has-text-warning">{{ $t("orders.ongoing") }} <i
            class="fa fa-spinner fa-spin" /></span>
        <span v-if="disputeStatus === 'granted'" class="has-text-success">{{ $t("driver.granted") }} <i
            class="fa fa-check-circle" /><span>
            +{{ disputeExtra }}</span>
        </span>
        <span v-if="disputeStatus === 'declined'" class="has-text-danger">{{ $t("driver.declined") }} <i
            class="fa fa-times-circle" /></span>
      </span>
      <span v-if="isSuperUser() && deliveryTransaction" class="has-text-info link is-pulled-right distance"
        @click="showResolve = !showResolve">Resolve&nbsp;<i class="fa fa-pencil-alt fa-sm" /></span>
      <div v-if="showResolve" style="margin-top: 16px">
        <div v-if="disputeStatus === 'ongoing'" class="is-flex" style="gap: 6px">
          <span class="button is-light" :class="{ 'is-outlined': disputeStatus === 'ongoing' }"
            @click="resolve('ongoing')">Ongoing&nbsp;<i class="fa fa-spinner fa-spin has-text-warning" /></span>
          <span class="button is-light" :class="{ 'is-outlined': disputeStatus === 'granted' }"
            @click="resolveGranted">Granted&nbsp;<i class="fa fa-check-circle has-text-success" /></span>
          <span class="button is-light" :class="{ 'is-outlined': disputeStatus === 'denied' }"
            @click="resolve('declined')">Declined&nbsp;<i class="fa fa-times-circle has-text-danger" /></span>
        </div>
        <p class="fare-info">
          Fare Info <span class="fare">Base {{ fare.price - fare.bonus }}</span>
          <span class="fare">Bonus {{ fare.bonus }}</span>
          <span class="fare has-text-info has-text-weight-bold">Extra {{ disputeExtra }}</span>
          <br />
          {{ deliveryTransaction.data.fare }}
        </p>
      </div>
    </div>

    <div v-if="isSuperUser()" class="source">
      {{ fare.source || "graphhopper*" }}
    </div>

    <input type="file" ref="file" style="display: none" accept="image/png,image/jpeg,image/jpg,image/bmp"
      @change="uploadPhoto($event)" />
  </div>
</template>

<script>
// import geo from "@/geo";
import L from "leaflet";
import "leaflet.locatecontrol";
import "leaflet.awesome-markers";
import photos from "@/photos";

const CachedTileLayer =
  require("@yaga/leaflet-cached-tile-layer").CachedTileLayer;

export default {
  name: "DriverShortestRouteMap",
  props: {
    commerceOrder: Object,
    // pickup: Object,
    // dropoff: Object,
    // route: String,
    // fare: Object,
  },
  data() {
    return {
      showResolve: false,
      mapID: "driver-shortest-route-map-map",
      map: null,
      warning: null,
      straightLine: null,
      layer: null, // main layer
      isClosed: false,
    };
  },
  computed: {
    deliveryTransaction() {
      return this.commerceOrder.delivery;
    },
    route() {
      return this.commerceOrder.data.delivery.predicted_route;
    },
    pickup() {
      return this.commerceOrder.data.business;
    },
    dropoff() {
      return this.commerceOrder.data.address;
    },
    fare() {
      return this.commerceOrder.data.fare;
    },
    fareDistanceKM() {
      return (this.fare.distance / 1000).toFixed(1);
    },
    minDispute() {
      // return (this.fare.distance / 1000 + 1).toFixed(1);
      return 1;
      // return Math.ceil(this.fareDistanceKM) + 1;
    },
    screenshot() {
      return this.commerceOrder.data.distance_dispute_pic;
    },
    disputeStatus() {
      return this.commerceOrder.data.distance_dispute_status;
    },
    disputeDistance() {
      return this.commerceOrder.data.distance_dispute_km;
    },
    disputeExtra() {
      return this.commerceOrder.data.distance_dispute_tukpay;
    },
    distanceDiffKM() {
      if (!this.disputeDistance) return 0;
      var metersDiff = (this.disputeDistance * 1000 - this.fare.distance);
      return metersDiff / 1000;
    }
  },
  mounted() {
    this.initMap();
    console.log("deliveryTransaction", this.deliveryTransaction);
  },
  methods: {
    close() {
      this.isClosed = true;
      this.$emit("close");
    },
    showFareDistanceKM() {
      if (this.isSuperUser()) this.infoToast(this.fareDistanceKM + "km");
    },
    viewScreenshot() {
      this.$swal({
        html: `<div style='text-align:left'>
        <p style='font-size:1.2em; margin-bottom:12px'>Dispute Screenshot</p>
        <p style='text-align:center'>
        <img src='${this.screenshot}' style='box-shadow: 0 0 2px black; border-radius:10px' />
        </p>
        </div>`,
        showCloseButton: true,
        showCancelButton: true,
        confirmButtonText: "Change Screenshot",
        cancelButtonText: this.$t("okay"),
        confirmButtonColor: "orange",
        cancelButtonColor: this.bulmaColor("info"),
      }).then((val) => {
        if (val.value) this.preDispute();
      });
    },
    preDispute() {
      var title = this.$t("driver.dispute-distance");
      var txt1 = this.$t("driver.to-dispute-distance"); // To dispute the driving distance: upload a screenshot from Google Maps showing the shortest motorbike driving directions.
      var txt2 = this.$t("driver.enter-dispute-distance-km"); // Enter shortest distance in km:
      this.$swal({
        html: `<div style='text-align:left'>
    <p style='font-size:1.2em; margin-bottom:12px'>
    <i class='fa fa-exclamation-triangle'></i>&nbsp;${title}
    </p>
    <p style='margin-bottom:10px'>${txt1}</p>
    <p><b>${txt2}</b></p>
    </div>`,
        input: "number",
        confirmButtonText: this.$t("upload-screenshot"), //"Upload Screenshot",
        cancelButtonText: this.$t("cancel"),
        showCancelButton: true,
        showCloseButton: true,
        inputValidator: (val) => {
          if (!val) return this.$t("driver.enter-dispute-distance-km"); //"Enter your dispute distance";
          if (parseFloat(val) <= this.minDispute)
            return this.$t("driver.dispute-distance-greater-than", {
              x: this.minDispute,
            });
          // return `Dispute distance must be greater than ${this.minDispute}km`;
          if (parseFloat(val) > 50)
            return this.$t("driver.enter-dispute-distance-km"); // "Enter distance in km";
        },
      }).then((val) => {
        if (val.value) {
          this.disputeDistanceKM = parseFloat(val.value);
          // this.infoToast(val.value);
          this.triggerUploadScreenshot();
        }
      });
    },
    triggerUploadScreenshot() {
      this.$refs.file.click();
      var loader = this.loadingDots("lightblue");
      setTimeout(() => loader.hide(), 5000);
    },
    uploadPhoto(e) {
      var dir = "delivery_dispute";
      var filename = this.$shortid.generate(); //${this.t.id}`;
      var businessID = this.commerceOrder.id; // doesn't need to be a businessID
      var callback = this.attachDisputeScreenshot;
      this.photoUploading = this.loadingDots("lightgreen");
      photos.uploadPhoto(e, this.$store, callback, dir, filename, businessID);
    },
    resolveGranted() {
      var defaultExtraAmount = Math.round(this.distanceDiffKM * 10) - 5;
      this.$swal({
        html: `<div style='text-align:left'>
        <p style='font-size:1.2em; margin-bottom:12px'>Granted Extra Bonus</p>
        <p style='margin-bottom:9px'>Enter the extra amount to pay driver for this delivery.</p>
        <p>This will be added to TukPay.</p>
        </div>`,
        showCloseButton: true,
        confirmButtonText: this.$t("submit"),
        input: "number",
        inputValue: defaultExtraAmount,
        inputValidator: (val) => {
          if (!val) return "Enter an amount";
        },
      }).then((val) => {
        if (val.value) {
          var bonus = parseInt(val.value);
          this.resolve("granted", bonus);
          this.addTukpay(bonus);
        }
      });
    },
    addTukpay(bonus) {
      var tukpay = this.deliveryTransaction.data.fare.tukpay;
      var newTukpay = tukpay + bonus;
      var data = {
        id: this.deliveryTransaction.id,
        tukpay: newTukpay,
      };
      var loader = this.loadingDots("orange");
      this.$store
        .dispatch("addTukpayToDelivery", data)
        .then(() => this.successToast("New TukPay: " + newTukpay))
        .catch((err) => this.apiError(err))
        .finally(() => loader.hide());
    },
    resolve(status, tukpay) {
      if (!tukpay) tukpay = 0;
      this.$store
        .dispatch("patchTransaction", {
          transactionID: this.commerceOrder.id,
          data: {
            data: {
              distance_dispute_status: status,
              distance_dispute_tukpay: tukpay,
            },
          },
        })
        .then(() => {
          this.successToast("Distance dispute resolved!");
          this.log("resolved_distance_dispute", this.commerceOrder.id);
          this.updateTransactionsForDriver(true);
          this.close();
        })
        .catch((err) => this.apiError(err));
    },
    attachDisputeScreenshot(picURL) {
      this.$store
        .dispatch("patchTransaction", {
          transactionID: this.commerceOrder.id,
          data: {
            data: {
              distance_dispute_pic: picURL,
              distance_dispute_km: this.disputeDistanceKM,
              distance_dispute_status: "ongoing",
            },
          },
        })
        .then(() => {
          this.successToast("Delivery Pic Uploaded");
          this.log("upload_distance_dispute_success", this.commerceOrder.id);
          var msg = `⚠️ Driver [ ${this.$store.getters.realName} ] 🛵 created distance dispute`;
          this.sendSuperuserNotification(msg);
          this.updateTransactionsForDriver(true);
          this.close();
          this.showDisputeSuccess();
        })
        .catch((err) => this.apiError(err))
        .finally(() => this.photoUploading.hide());
    },
    showDisputeSuccess() {
      var txt1 = this.$t("driver.check-dispute-in-wallet");
      var txt2 = this.$t("driver.dispute-result-will-show");
      this.$swal({
        type: "success",
        animation: true,
        html: `<div style='text-align:left'>
    <p style='margin-bottom:12px'>${txt1}</p>
    <p>${txt2}</p>
    </div>`,
        confirmButtonText: this.$t("okay"),
      }).then(() => this.refreshPage());
    },
    initMap() {
      var tilesURL = this.$t("geo.map-tiles"); // language specific maps

      this.map = L.map(this.mapID, { attributionControl: false });
      this.map.setView(this.pickup, 17);
      L.tileLayer(tilesURL, {
        tileSize: 512,
        zoomOffset: -1,
        // minZoom: 12,
        maxZoom: 19,
      }).addTo(this.map);

      new CachedTileLayer(tilesURL, {
        tileSize: 512,
        zoomOffset: -1,
        minZoom: 2,
        maxZoom: 19,
        // useCache: false,
        // cacheMaxAge: 1000 * 60 * 60 * 24 * 30, // 30 days
        crossOrigin: true,
        maxAge: 1000 * 60 * 60 * 24 * 30, // optional, default is 7 days
      }).addTo(this.map);

      this.map.zoomControl.remove();
      // var position = { position: "bottomright" };
      // L.control.zoom(position).addTo(this.map);

      this.layer = L.featureGroup().addTo(this.map);

      // this.drawUserLocation();

      var pickupIcon = L.AwesomeMarkers.icon({
        icon: "store-alt", //"street-view",
        markerColor: "blue",
      });

      var dropoffIcon = L.AwesomeMarkers.icon({
        icon: "flag-checkered",
        markerColor: "lightgreen",
        iconColor: "blue",
        extraClasses: "fa-lg",
      });

      // create markers, add to map and fit
      var pickupMarker = L.marker(this.pickup, {
        icon: pickupIcon,
        draggable: true,
      });
      pickupMarker.addTo(this.layer);
      var dropoffMarker = L.marker(this.dropoff, {
        icon: dropoffIcon,
        draggable: true,
      });
      dropoffMarker.addTo(this.layer);

      // make markers removable on drag
      pickupMarker.on("dragend", () => this.layer.removeLayer(pickupMarker));
      dropoffMarker.on("dragend", () => this.layer.removeLayer(dropoffMarker));

      var group = new L.featureGroup([pickupMarker, dropoffMarker]);
      var padding = { padding: [50, 50] };
      this.map.fitBounds(group.getBounds(), padding);
      // this.shiftMapDown();

      // add popups
      var opts = { closeButton: false, autoPan: true };
      var pStr = this.$t("driver.pickup");
      var dStr = this.$t("driver.dropoff");
      var pickupName = this.pickup.name || this.$t("ride.pin-location");
      var dropoffName = this.dropoff.name || this.$t("ride.pin-location");
      pickupMarker.bindPopup(`<i>${pStr}</i><br>${pickupName}`, opts);
      dropoffMarker.bindPopup(`<i>${dStr}</i><br>${dropoffName}`, opts);
      setTimeout(() => pickupMarker.openPopup(), 1000);
      setTimeout(() => dropoffMarker.openPopup(), 3000);
      // setTimeout(() => pickupMarker.openPopup(), 5000);

      if (this.route) this.drawDrivingRoute(this.route);
      else this.drawStraightLine();
    },
    shiftMapDown() {
      this.map.panBy(new L.Point(0, -50), { animate: true });
    },
    drawStraightLine() {
      var dashLine = {
        color: "#0394fc",
        weight: "3",
        opacity: 0.6,
        dashArray: "6, 6",
        lineCap: "square",
      };
      var latlngs = Array();
      latlngs.push(this.pickup);
      latlngs.push(this.dropoff);
      this.straightLine = L.polyline(latlngs, dashLine).addTo(this.map);
    },
    drawDrivingRoute(encoded) {
      var polyUtil = require("polyline-encoded");
      var array = polyUtil.decode(encoded);
      var polyline = new L.polyline(array, {
        color: "#0394fc",
        weight: 5,
        opacity: 0.6,
      });
      polyline.addTo(this.map);
      var group = new L.featureGroup([polyline]);
      var padding = { padding: [50, 50] };
      this.map.fitBounds(group.getBounds(), padding);
      if (this.straightLine) this.map.removeLayer(this.straightLine); // remove the straight line
      setTimeout(() => this.shiftMapDown(), 500);
    },
  },
};
</script>

<style scoped>
/* .driver-shortest-route-map {
} */
.map-wrapper {
  position: absolute;
  bottom: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
  /* z-index: 9999; */
  z-index: 1;
}

.map {
  position: relative;
  height: 100%;
  width: 100%;
}

.bottom {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100vw;
  background-color: #ddd;
  padding: 12px 16px;
  /* z-index: 1101; */
  z-index: 2;
  box-shadow: 0 0 3px black;
}

.warning.tag {
  border-radius: 0;
}

.dispute {
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  background-color: #333;
  padding: 12px;
  z-index: 2;
  box-shadow: 0 0 3px black;
  text-align: left;
  color: white;
}

.is-flex .button {
  flex: 1;
}

.distance {
  /* background-color: #777; */
  background-color: #ddd;
  color: #333;
  border-radius: 3px;
  padding: 0 4px;
  display: inline-block;
  border: 1px solid white;
  font-weight: 500;
}

.distance.dark {
  background-color: #333;
  color: white;
}

.fare-info {
  margin: 12px 0;
  background-color: #666;
  border-radius: 3px;
  padding: 0 4px;
}

.fare {
  display: inline-block;
  background-color: #444;
  border-radius: 3px;
  padding: 0 3px;
  margin: 4px;
}

.source {
  position: absolute;
  bottom: 60px;
  right: 10px;
  z-index: 2;
  background-color: rgba(0, 0, 0, 0.8);
  color: white;
  border-radius: 3px;
  padding: 0 3px;
}
</style>

<style lang="scss">
#driver-shortest-route-map-map {
  .leaflet-control-locate {
    border-radius: 50%;
  }

  .leaflet-control-locate a {
    border-radius: 50%;
  }

  .leaflet-popup-content {
    padding: 5px 5px;
    margin: 1px 0;
    // color: rgb(23, 23, 193);
    color: rgb(23, 102, 193);
    font-size: 1.2em;
    max-width: 130px;
  }

  .leaflet-popup-content i {
    font-weight: 500;
    opacity: 0.8;
    color: grey;
  }
}
</style>